import { Component, OnInit, OnDestroy, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { SearchService } from '../../../search/search.service';
import { SearchEvent } from '../../../search/models/search-event';
import { NEW_SEARCH_EVENT, NEW_ROW_EVENT, PAGE_OVERFLOW_EVENT, INSERT_ROW_EVENT, IS_DETAIL_PAGE_DATA_LOADED } from '../../../search/search-constants';
import { ResourceService } from 'sce-core';
import { UserService } from '../../../../core/security/user.service';
import { NavigationService } from '../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { DetailViewKeyEventHandlerService } from '../../../services/detail-view-key-event-handler.service';
import { SearchableEntityConfig } from '../../../models/searchable-entity-config';
import { SearchableEntityServiceFactory } from '../../../services/searchable-entity/searchable-entity-service-factory';
import { ActivatedRoute } from '@angular/router';
import { LeftPanelService } from '../../../../layout/home/services/left-panel.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { DetailedEntityDataService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { DetailedEntityButtonService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { DetailedEntityDataEditorService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { UserPreferenceService } from '../../../../layout/home/services/user-preference.service';
import { TablePreference } from '../../../search/models/table-preference.model';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { FormPageConfig } from '../../../models/form-page-config';
import { SORTING_FROM_BE_TD } from 'app/constants';

@Component({
  selector: 'lfwms-searchable-entity-dynamic-details',
  templateUrl: './dynamic-details-page.component.html',
  styleUrls: ['./dynamic-details-page.component.css']
})
export class SearchableEntityDynamicDetailsComponent implements OnInit, OnDestroy {

  @Input() public serviceFactory: SearchableEntityServiceFactory;

  // generic services
  protected dataService: DetailedEntityDataService;
  protected buttonService: DetailedEntityButtonService;
  protected dataEditor: DetailedEntityDataEditorService;

  // Service to maintain Master Data for Primary & Secondary Accordions in the Details Page
  protected primarySearchService: SearchService;
  // Search Service which is passed as input to Data Table inside Details Accordion
  protected detailsSearchService: SearchService;

  // the column group user preference
  public columnGroupUserPreference: any;

  /* Map Object <K,V> to maintain Cell Metadata [ for Primary & Secondary Accordions ] in the Details Page.
     This metadata is readily available from the Data Service and hence no fresh fetch is required. */
  public metadataMap: any;
  /* Map Object <K,V> to maintain Cell Data [ for Primary & Secondary Accordions ] in the Details Page.
     A fresh fetch is fired each time against a Receipt Key (dataService.primarySelectedDocument) from ngOnInit() */
  public cellDataMap: any;

  private keyEventHandler: DetailViewKeyEventHandlerService;

  // public isLoading: boolean = false;

  // public isPrimaryDataLoaded: boolean = false;

  // variable to store all object level sunscriptions. This will be unsubscribed on component destroy
  private subscriptionLists: Array<Subscription>;
  // Flag to show/hide Details Accordion
  // public showDetailsSection: boolean = false;
  // Flag to expand/collapse Details Accordion
  public expandDetailsSection: boolean = true;

  public entityConfig: SearchableEntityConfig;
  public showBreadcrumbLabel = false;
  public selectedValue: String;

  // public primaryAccordion: AccordionConfig;
  // public secondaryAccordionList: Array<AccordionConfig>;
  // flag indicating if the state should be retained
  private retainState: boolean;
  // variables for smooth scrolling of floating menu
  private floatingMenuOffset;
  public isStickyFloatingMenu: boolean;
  private previousScroll = 0;
  private isScrollDown = false;

  protected navService: NavigationService;
  protected resourceService: ResourceService;
  protected userService: UserService;
  // private activatedRoute: ActivatedRoute;
  protected alertService: AlertService;
  protected confirmDialogService: ConfirmDialogService;
  protected tablePreferences: UserPreferenceService;
  public tablePreference: TablePreference;

  public pageConfig: FormPageConfig;

  public columnGroupWidgetList: Array<LFDynamicWidgetConfig>;
  public floatingPanelWidget: LFDynamicWidgetConfig;

  @ViewChild('floatingMenuId', { read: ElementRef }) navbarif: ElementRef;
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.floatingMenuOffset = this.navbarif.nativeElement.offsetTop;
    if (this.previousScroll < window.pageYOffset) {
      this.isScrollDown = true;
    } else {
      this.isScrollDown = false;
    }
    this.previousScroll = window.pageYOffset;
    // floating menu is getting fixed when height is 40 px from top, that is why we are adding/subtracting 39 px
    // to the offset. So that there wont be any sudden jumps during scrolling.
    if ((window.pageYOffset + (this.isScrollDown ? 103 : -103)) >= (this.floatingMenuOffset)) {
      this.isStickyFloatingMenu = true;
    } else {
      this.isStickyFloatingMenu = false;
    }
  }

  constructor(private coreServiceRegistry: CoreServiceRegistry, private sharedServiceRegistry: SharedServiceRegistry,
    public leftPanelService: LeftPanelService, private activatedRoute: ActivatedRoute) {
    this.navService = coreServiceRegistry.navigationService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.userService = coreServiceRegistry.userService;
    this.alertService = sharedServiceRegistry.alertService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
    this.tablePreferences = sharedServiceRegistry.userPreferencesService;
    //  this.activatedRoute = coreServiceRegistry.activatedRoute;

    // Initializing Cell Data Map
    this.cellDataMap = {};
    this.subscriptionLists = [];
  }


  /**
   * Initializes the component
   */
  public ngOnInit() {
    this.initializeProperties();
    this.pageConfig.isPageLoaded = false;
    this.activatedRoute.params.subscribe(params => {
      // set all load flags to false
      this.pageConfig.isPageLoaded = false;
      this.pageConfig.isPrimarySectionLoaded = false;
      this.pageConfig.isDetailSectionLoaded = false;

      const docId = params['docId'];
      // LFWM-2045,accessing storerkey to create the search criteria for skutd loadbypage
      if (params['storer']) {
        this.dataService.primarySearchParams.storerKey = params['storer'];
        }
      let retainState = null;
      if (this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams['retainState']) {
        retainState = this.activatedRoute.snapshot.queryParams['retainState'];
      }
      if (docId) { // ie, if navigated via route param
        this.dataService.setPrimarySelectedDocument(docId);
        this.navService.setPageTitle(this.entityConfig.getItemLabel() + ' # ' + docId);
      } else {
        // if there is no id provided, then go to the create flow
        this.dataService.displayMode = 'C';
        this.navService.setPageTitle(this.resourceService.get('lbl_create').concat(' ').concat(this.entityConfig.getItemLabel()));
      }

      if (retainState && retainState === '1') {
        this.retainState = true;
      } else {
        this.retainState = false;
      }
      // Initialize the page once the metadata is available
      this.primarySearchService.fetchMetadata().subscribe(metadata => {
        this.initializePrimaryMetadataMap(metadata);
        this.initializePage();
        this.pageConfig.isPageLoaded = true;
      });
    });
  }

  /**
   * Initializes the component properties
   */
  private initializeProperties() {
    this.dataService = <DetailedEntityDataService>this.serviceFactory.getDataService();
    this.entityConfig = this.dataService.getEntityConfiguration();
    this.buttonService = <DetailedEntityButtonService>this.serviceFactory.getButtonService();
    this.dataEditor = <DetailedEntityDataEditorService>this.serviceFactory.getDataEditor();
    this.primarySearchService = this.dataService.getPrimarySearchService();
    this.keyEventHandler = new DetailViewKeyEventHandlerService(this.dataEditor);

    this.pageConfig = this.dataService.entityConfig.formPageConfig;
    this.pageConfig.detailPageComponent = this;
    this.pageConfig.dataService = this.dataService;
    this.pageConfig.buttonService = this.buttonService;
    this.pageConfig.dataEditor = this.dataEditor;
    this.pageConfig.keyEventHandler = this.keyEventHandler;
    this.pageConfig.pageLabel = this.entityConfig.getItemLabel();
    this.pageConfig.showDetailsSection = this.entityConfig.getShowDetailLineItems();
  }

  // initializes the page based on the display mode.
  // C - create flow - This can only come from search page, so the metadata is already loaded
  // E - edit flow - This can only come from view page, so the metadata is already loaded
  // V - view flow - This can come from search page, recent items, direct url etc. Metadata may or may not be available
  protected initializePage() {
    /*[LFWM-2132] - to determine we are in which page when updating some values both in accordion and table
      or when performing any button actions */
      this.dataService.pageType = 'details';
    // create flow
    if (this.dataService.displayMode === 'C') {
      this.initializePageForCreate();
    } else {
      // this can be either a view or an edit flow
      const itemNumber: string = this.dataService.getPrimarySelectedDocument();
      /* [LFWM-2159] - dynamicButtonsExist - false and need to empty the dynamic buttons array
      before fetching dynamic buttons from backend when loading details page */
      this.buttonService.dynamicButtonsExist = false;
      this.buttonService.dynamicButtons = [];
      if (!itemNumber) {
        // if this is an invalid or a deleted item, show error
        this.alertService.error(this.resourceService.get('msg_no_itm'));
        return;
      }

      // edit mode is supported only when retainState route param is true
      if (this.dataService.displayMode === 'E' && this.retainState) {
        this.initializePageForEdit(itemNumber);
      } else {
        this.dataService.displayMode = 'V';
        this.initializePageForView(itemNumber);
      }
    }
  }

  // Initializes the page specific to the create flow
  protected initializePageForCreate() {
    if (this.primarySearchService.searchParams.autoGenerateIdProperty) {
      // If Auto Generat Detail Id, Item Number has to be generated
      const uniqueIdSubscription = this.primarySearchService.createUniqueId(this.entityConfig.getType())
        .subscribe((response: any) => {
          if (response && response.documentNumber) {
            const documentNumber = response.documentNumber;
            this.dataService.setPrimarySelectedDocument(documentNumber);
            // create cell data map with default values
            this.cellDataMap = this.dataService.createNewRecord();
            this.initializePrimarySection(documentNumber);
            this.navService.preventNavigation = true;
            // For screens with line items in details page

          } else {
            this.alertService.error(this.entityConfig.getItemLabel() + ' '
              + this.resourceService.get('err_creation_failed'));
          }
        });

      this.subscriptionLists.push(uniqueIdSubscription);
    } else {
      // JIRA-824 - To clear the PrimarySelectedDocument Value
      this.dataService.setPrimarySelectedDocument('');
      // create cell data map with default values
      this.cellDataMap = this.dataService.createNewRecord();
      this.initializePrimarySection('');
      this.navService.preventNavigation = true;
    }
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      this.dataService.detailsSearchService = null;
      this.initializeDetailTable(false);
    }
    // removed the code for calling initializedetailTable to a few line above
  }

  // Initializes the page specific to the edit flow. The data for the page is already loaded
  protected initializePageForEdit(selectedItem) {
    // if the page allows saved state, do not load the data from the server. Simply load the page
    this.cellDataMap = this.dataService.getPrimaryDataMap();
    this.initializePrimarySection(selectedItem);
    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      this.initializeDetailTable(false);
    }
  }

  // Initializes the page specific to the view flow
  protected initializePageForView(selectedItem) {
    const cellDefinitionsSubscription = this.primarySearchService
      .getItemDetailForId(this.primarySearchService.searchParams.idProperty, selectedItem)
      .subscribe((response: any) => {
        // set cell data map
        if (!response || !response.cells) {
          this.alertService.error(this.resourceService.get('msg_invalid') + this.entityConfig.getItemLabel());
          this.navService.addNonNavigableBreadCrumb(this.entityConfig.getBreadCrumbPrefix() + selectedItem);
          return;
        }
        response.cells.forEach((cell: any) => {
          cell.isEdited = false;
          this.cellDataMap[cell.cName] = cell;
        });
        this.initializePrimarySection(selectedItem);
      });
    this.subscriptionLists.push(cellDefinitionsSubscription);

    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      this.initializeDetailTable(true);
    }
  }

  // loads the primary section which includes all accordian groups
  protected initializePrimarySection(itemNumber) {
    this.dataService.setPrimaryDataMap(this.cellDataMap);
    this.pageConfig.cellDataMap = this.cellDataMap;
    this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
    this.navService.addNonNavigableBreadCrumb(this.entityConfig.getBreadCrumbPrefix() + itemNumber);
    this.pageConfig.isPrimarySectionLoaded = true;
    if(this.primarySearchService.searchParams.tableEditor)
      this.primarySearchService.searchParams.tableEditor.setPrimaryData(this.cellDataMap);
    
    const event = new SearchEvent(IS_DETAIL_PAGE_DATA_LOADED);
    this.primarySearchService.publishEvent(event);
  }

  private initializePrimaryMetadataMap(metadata) {
    this.metadataMap = {};
    this.metadataMap['columnList'] = [];
    const columnsByGroup = {};
    this.columnGroupUserPreference = {};
    const columnGroupWidgetList: Array<LFDynamicWidgetConfig> = [];

    // Metadata for Primary & Secondary Accordions are readily available in Primary Search Service
    metadata.columnList.map((column: any) => {
      /*If there is any hidden property for an accordion that should be eliminated*/
      if (this.entityConfig.formPageConfig.hiddenPropertiesForAccordion.length > 0 &&
        this.entityConfig.formPageConfig.hiddenPropertiesForAccordion.indexOf(column.propertyName) !== -1) {
        return;
      }
      // Metadata.columnList is iterated and categorized based on columnGroup
      if (!columnsByGroup[column.columnGroup]) {
        columnsByGroup[column.columnGroup] = [];
        if (column.columnGroup !== 'Primary' && column.columnGroup !== 'ACCORDION') {
          this.columnGroupUserPreference[column.columnGroup] = Object.keys(this.columnGroupUserPreference).length;
        }
      }
      columnsByGroup[column.columnGroup].push(column.propertyName);
      this.metadataMap[column.propertyName] = column;
    });
    this.tablePreference = this.primarySearchService.getTablePreference();
    this.pageConfig.userPreference = this.tablePreference;
    if (Object.keys(this.tablePreference.columGroupConfig.configuration).length === 0) {
      this.tablePreference.columGroupConfig.configuration = this.columnGroupUserPreference;
    } else {
      this.columnGroupUserPreference = this.tablePreference.columGroupConfig.configuration;
    }
    Object.keys(columnsByGroup).forEach((columnGroup: any) => {
      // if the column group name is ACCORDION, then do not show it
      if (columnGroup === 'ACCORDION') {
        return;
      }
      const columnGroupWidget = new LFDynamicWidgetConfig();
      columnGroupWidget.columnGroup = columnGroup;
      columnGroupWidget.propertyList = columnsByGroup[columnGroup];
      columnGroupWidget.id = columnGroup;
      columnGroupWidget.name = this.resourceService.get(columnGroup);
      columnGroupWidget.activeIndex = this.columnGroupUserPreference[columnGroup];
      //      columnGroupWidget.widgetType = (columnGroup === 'Primary') ? 'P' : 'S';
      if (this.pageConfig.floatingPanelColumnGroup
        && this.pageConfig.floatingPanelColumnGroup === columnGroup) {
        this.floatingPanelWidget = columnGroupWidget;
      } else {
        columnGroupWidgetList.push(columnGroupWidget);
      }
    });

    // if there is no default accordion specified, initialize a default one
    if (this.entityConfig.setShowDetailLineItems) {
      const detailWidget = new LFDynamicWidgetConfig();
      detailWidget.id = 'Details';
      detailWidget.name = 'Details';
      columnGroupWidgetList.push(detailWidget);
    }
    // this.customizeMetadataMap();
    this.dataService.primaryMetaDataMap = this.metadataMap;
    this.pageConfig.metaDataMap = this.metadataMap;
    this.dataService.primaryColumnGrouping = columnsByGroup;
    this.columnGroupWidgetList = columnGroupWidgetList;
    // the below code is added to override the metadata object
    this.dataService.overrideMetadataMap(this.dataService.displayMode);
  }

  // Method to Customize Metadata for Display Only Changes
  private customizeMetadataMap() {
    // Overriding Metadata for facility to display it in ['Key - Value'] format
    // Below, Deep Clone has to be performed to avoid directly updating Metadata Object in Service
    if (!this.metadataMap['facility']) {
      return;
    }
    const facilityMetadata = JSON.parse(JSON.stringify(this.metadataMap['facility']));
    facilityMetadata.values.forEach((option) => {
      option.value = option.key + ' - ' + option.value;
    });
    this.metadataMap['facility'] = facilityMetadata;
  }

  public getBreadCrumbText() {
    if (this.dataService.getPrimarySelectedDocument()) {
      this.selectedValue = this.entityConfig.getBreadCrumbPrefix() + this.dataService.getPrimarySelectedDocument();
      this.showBreadcrumbLabel = true;
      return true;
    }
  }

  // initializes the line item detail table
  public initializeDetailTable(loadDataFromServer) {
    // if the retainState flag is set, do not reinitialize the service. Use the service already loaded in the memory
    if (!this.retainState || !this.dataService.getDetailsSearchService()) {
      this.dataService.initializeDetailsSearchContext();
    }
    this.detailsSearchService = this.dataService.getDetailsSearchService();
    //LFWM-3363 resetting the max line number for every new detail table
    this.dataService.maxIdValueForDetailTable='';    
    const metadataSubscription = this.detailsSearchService.fetchMetadata().subscribe((metadata) => {
      if (!SORTING_FROM_BE_TD.includes(this.detailsSearchService.searchParams.tableId)) {
        metadata.columnList.sort((a, b) => {
          return a.index - b.index;
        });
      }
      if (loadDataFromServer) {
        this.loadDetailTable();
      } else {
        this.pageConfig.isDetailSectionLoaded = true;
      }
      // this.showDetailsSection = true;
      this.expandDetailsSection = true;
    });
    this.subscriptionLists.push(metadataSubscription);

    // Subscription for the Search Events from Details Search Service.
    const detailsSearchEventSubscription = this.detailsSearchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
        if (event.type === NEW_SEARCH_EVENT && this.detailsSearchService.getMetadata()) {
          // For NEW_SEARCH_EVENT, the Details Data Table will be displayed
          this.pageConfig.isDetailSectionLoaded = true;
        } else if (event.type === NEW_ROW_EVENT || event.type === INSERT_ROW_EVENT) {
          // For NEW_ROW_EVENT
          this.dataService.handleAddNewLineItem(event);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.detailsSearchService.setNewPageEventInProgress(true);
          this.buttonService.performButtonActions('Save');
        }
      });
    this.subscriptionLists.push(detailsSearchEventSubscription);
  }

  // Method to load Data Table in Details Accordion
  protected loadDetailTable() {
    // Setting Search Criteria in Details Search Service which is the input for Data Table in Details Accordion

    this.detailsSearchService.setSearchCriteria({
      conditions: [{
        mandatory: false,
        clauses: [{
          column: this.primarySearchService.searchParams.idProperty,
          operation: '=',
          value: this.dataService.getPrimarySelectedDocument(),
          logicalOperation: null
        }],
        logicalOperation: null
      }]
    });
        if (!this.dataService.getPrimarySelectedDocument()) {
      this.detailsSearchService.searchStatus.hasResults = true;
      const event = new SearchEvent(NEW_SEARCH_EVENT);
      event.isSearchSuccess = true;
      this.detailsSearchService.publishEvent(event);
      return;
    }
    /* Invoking Search in DetailsSearchService. The above eventSubscription listens to
       the New Search Event fired as a result of the below method */
    this.detailsSearchService.performSearch();
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  // Method to return Cell Title corresponding to each property
  public getCellTitle(property: any): string {
    return this.resourceService.get(this.metadataMap[property].elementId);
  }

  // Method  to override default display format for each cell value (in VIEW Mode ONLY)
  public getCellDisplayValue(property: any): any {
    return ''; // this.dataService.getCellDisplayValue(property, this.isLoading);
  }

  private openLookup(cells: any, property: any) {
    const row = { cells: this.cellDataMap };
    this.dataEditor.openLookup(row, property);
  }

  public ngOnDestroy() {
    if (this.subscriptionLists) {
      this.subscriptionLists.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
    if (this.dataService) {
      this.dataService.handleDestroyDetails();
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/searchable-entity/dynamic-details-page/dynamic-details-page.component.ts